import Login from "screens/login";
import Home from "screens/home";
import BlankPage from "screens/blank-page";
import AddProduct from "screens/add-product";
import ProductList from "screens/product-list";
import Orders from "screens/orders";
import TeamList from "screens/team";
import ProfilePage from "screens/profile";

export const routes = {
    Login: {
        path: "/login",
        name: "Root",
        element: <Login/>,
        isProtected: false
    },
    Home: {
        path: "/",
        name: "Home",
        element: <Home/>,
        isProtected: true
    },
    Orders: {
        path: "/orders",
        name: "Orders",
        element: <Orders/>,
        isProtected: true
    },
    Changelog: {
        path: "/changelog",
        name: "Changelog",
        element: <BlankPage/>,
        isProtected: true
    },
    AddProduct: {
        path: "/add-product",
        name: "Add Product",
        element: <AddProduct/>,
        isProtected: true
    },
    ProductList: {
        path: "/product-listing",
        name: "Product List",
        element: <ProductList/>,
        isProtected: true
    },
    TeamList: {
        path: "/team",
        name: "Team",
        element: <TeamList/>,
        isProtected: true
    },
    ProfilePage: {
        path: "/user-profile",
        name: "Profile",
        element: <ProfilePage/>,
        isProtected: true
    }
};
